import { render, staticRenderFns } from "./contracts-all.vue?vue&type=template&id=224fe4be"
import script from "./contracts-all.vue?vue&type=script&lang=js"
export * from "./contracts-all.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports